import type { ReactNode } from 'react';

export type StatusTone = 'positive' | 'attention' | 'negative' | 'neutral';

const toneClass: Record<StatusTone, string> = {
  positive: 'schd-status-positive',
  attention: 'schd-status-attention',
  negative: 'schd-status-negative',
  neutral: 'schd-status-neutral',
};

export function StatusBadge({ tone, children }: { tone: StatusTone; children: ReactNode }) {
  return <span className={`schd-status ${toneClass[tone]}`}>{children}</span>;
}
